export default __webpack_public_path__ + "static/playstore-cedfcaac217d4c9aa708bb5fc1520135.png";